// projects/humanresources-personnel/src/assets/i18n/*/hr-per-physical-standard.json
export class HrPerPhysicalStandardKey {
    private static readonly keyPrefix = 'hrPerPhysicalStandard';
    public static title = `${HrPerPhysicalStandardKey.keyPrefix}.title`;
    public static pageHeader = `${HrPerPhysicalStandardKey.keyPrefix}.pageHeader`;
    public static eyeColor = `${HrPerPhysicalStandardKey.keyPrefix}.eyeColor`;
    public static hairColor = `${HrPerPhysicalStandardKey.keyPrefix}.hairColor`;
    public static skinColor = `${HrPerPhysicalStandardKey.keyPrefix}.skinColor`;
    public static height = `${HrPerPhysicalStandardKey.keyPrefix}.height`;
    public static weight = `${HrPerPhysicalStandardKey.keyPrefix}.weight`;
    public static bmi = `${HrPerPhysicalStandardKey.keyPrefix}.bmi`;
    public static waistline = `${HrPerPhysicalStandardKey.keyPrefix}.waistline`;
    public static handUsed = `${HrPerPhysicalStandardKey.keyPrefix}.handUsed`;
    public static footUsed = `${HrPerPhysicalStandardKey.keyPrefix}.footUsed`;
    public static enumLimbUsed = `${HrPerPhysicalStandardKey.keyPrefix}.enumLimbUsed`;
}
